<template>
    <v-dialog v-model="congratulations" max-width="446" content-class="white">
        
        <v-layout column align-center class="text-center px-16px pt-52px pb-40px">
            <h2 class="tit tit--lg lightblue--text mb-6px">
                당첨을 <br>
                축하합니다!
            </h2>

            <!-- 상품사진 -->            
            <!-- <img :src="config?.image2" /> -->

            <!-- 아이패드 에어 5세대 -->
            <v-img :src="config?.image2" max-width="100%" width="414" :aspect-ratio="414 / 224" class="mb-6 mb-md-8" />
            <!-- 상품명 -->
            <h3 class="tit mb-1">
                {{ config?.name }}
            </h3>
            <p v-if="[1, 2].includes(config?.ranking)" class="txt grey-94--text font-weight-bold">
                당첨관련 안내를 위해 개별적으로 연락드릴 예정입니다.
            </p>
            <v-btn to="/mypage/event" color="#59B6E5" dark class="white--text mt-6 mt-md-8">마이페이지 바로가기</v-btn>
        </v-layout>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            congratulations: false,
            config: null,
        };
    },
    methods: {
        open(config) {
            this.config = config;
            this.congratulations = true;
        },
        close() {
            this.congratulations = false;
            this.config = null;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_event.scss";

::v-deep{
    .v-dialog{
        border-radius: 24px !important;
    }
}

@media (min-width:576px){
}
@media (min-width:768px){
    ::v-deep{
        .v-dialog{
            border-radius: 52px !important;
        }
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>
